const config = {
  baseUrl: process.env.REACT_APP_API_URL,
} as const;

export default config;
